import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { database, ref, get } from "../../firebase";
import { checkAndSetStats } from "../../helpers/helpers";
import Footer from "../../components/Footer";
import "./styles.css";
import ImagesGrid from "../../components/ImagesGrid";
import { COLLECTIONS_DATA } from "../../constants/constants";
import Navigation from "../../components/Navigation";

function Exchange() {
    const [exchangeData, setExchangeData] = useState(false);
    const doesStatsSent = useRef(false);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#FFFFFF";

        const dbRef = ref(database, "/landing/exchange");

        get(dbRef)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setExchangeData(snapshot.val());
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("exchangePage");
            doesStatsSent.current = true;
        }
    }, []);

    return (
        <div className="exchange bg-white">
            <Navigation showBack backTo="/" variant="light" />

            <div className="flex flex-col uppercase items-center tsatsky-bold-font border-b">
                <div className="text-sm mt-8">Актуальна ціна на обмін</div>
                <div className="text-[55px] text-exchangeRed">
                    {exchangeData.price || "0000"}
                </div>
                <div className="text-sm">грн/грам</div>
                <div className="text-sm mt-6 mb-8 flex items-center">
                    Згідно з біржею:{" "}
                    <a
                        target="_blank"
                        className="bg-exchangeRed uppercase leading-3 ml-2 rounded-sm text-white text-[7px] px-3 py-[3px]"
                        href={exchangeData.stockExchangeLink || "/"}
                        rel="noreferrer"
                    >
                        {exchangeData.stockExchangeName || "Loading..."}
                    </a>
                </div>
            </div>

            <div className="flex flex-col items-center">
                <div className="text-sm mt-8 tsatsky-bold-font">
                    НАШІ КОЛЕКЦІЇ:
                </div>

                <ImagesGrid data={COLLECTIONS_DATA} />
            </div>

            <Footer containerClassNames={"bg-exchangeRed text-white"} isDark />
        </div>
    );
}

export default Exchange;
